import { Role } from '../../../../enums/Role';
import { GetPermissionFn } from '../types';

export const getAdministrationPermission: GetPermissionFn = ({
  isWorkspaceOwner,
  hasRole
}) => {
  if (hasRole(Role.planningReadonly) || !isWorkspaceOwner) {
    return { canView: false, canEdit: false };
  }
  return { canView: true, canEdit: true };
};
